import ability from '@/libs/acl/ability'
import {SLOT_TYPES} from '@/config/layoutConfig'
import {buildUnitCamerasGridItems} from '@/utils/gridUtils'

class VideoViewService {
    constructor(store) {
        this.store = store
    }

    async setUnitLiveVideo(data) {
        const slots = this.createLiveVideoSlots(data)
        const resolveName = this.resolveUnitName(data)
        const tabName = `Live Video ${resolveName}`

        const tab = await this.store.dispatch("grid/addNewTab", {
            tabName,
            layout: 'unit-live',
            slots
        })

        if (tab.status) {
            await this.store.dispatch("grid/setActiveTab", tab.id)
            this.store.commit("grid/forceLayoutSlots", slots)
        }
    }

    async setUnitCamerasView(data) {
        const cameras = data.data.cameras ? data.data.cameras : data.cameras
        const resolveName = this.resolveUnitName(data)
        const tabName = `Cámaras ${resolveName}`

        if (!ability.can('live_video', 'Video') || !Array.isArray(cameras) || cameras.length === 0) {
            return
        }

        // Mismos slots que al arrastrar una cámara del árbol al grid,
        const gridConfig = buildUnitCamerasGridItems(cameras.length)
        const slots = cameras.slice(0, gridConfig.length).map((camera, index) => {
            const gridItem = gridConfig.find(item => item.pos === index + 1) || gridConfig[index]
            return {
                name: camera.name,
                pos: index + 1,
                data: {
                    camera,
                    region: data.data.region ?? '',
                },
                type: SLOT_TYPES.CAM_LIVE,
                id: gridItem.id,
            }
        })

        const tab = await this.store.dispatch("grid/addNewTab", {
            tabName,
            layout: 'unit-cameras',
            slots
        })

        if (tab.status) {
            await this.store.dispatch("grid/setActiveTab", tab.id)
            this.store.commit("grid/forceLayoutSlots", slots)
        }
    }

    async setUnitRecordingVideo(data) {
        const slots = this.createRecordingVideoSlots(data)
        const resolveName = this.resolveUnitName(data)
        const tabName = `Recording Video ${resolveName}`

        const tab = await this.store.dispatch("grid/addNewTab", {
            tabName,
            layout: 'unit-recording',
            slots
        })

        if (tab.status) {
            await this.store.dispatch("grid/setActiveTab", tab.id)
            this.store.commit("grid/forceLayoutSlots", slots)
        }
    }

    createLiveVideoSlots(data) {
        return this.createVideoSlots(data, SLOT_TYPES.CAM_LIVE, 'live_video')
    }

    createRecordingVideoSlots(data) {
        return this.createVideoSlots(data, SLOT_TYPES.CAM_RECORDED, 'record_video')
    }

    createVideoSlots(data, slotType, permission) {
        const slots = []
        const cameras = data.data.cameras ? data.data.cameras : data.cameras
        const cameraCount = Math.min(cameras.length, 6)
        const layoutType = cameraCount > 4 ? 'liveVideo5x1Layout' : 'liveVideoLayout'
        const gridConfig = this.getGridConfig(layoutType)

        if (ability.can(permission, 'Video')) {
            for (let index = 0; index < cameraCount; index++) {
                const gridItem = gridConfig.find(item => item.pos === index + 1) || gridConfig[index]
                slots.push({
                    name: cameras[index].name,
                    pos: index + 1,
                    data: {
                        camera: cameras[index],
                        region: '',
                    },
                    type: slotType,
                    id: gridItem.id,
                })
            }
        }

        return slots
    }

    getGridConfig(layoutType) {
        return layoutType === 'liveVideo5x1Layout'
            ? require('@/config/liveVideo5x1Layout').default.grid
            : require('@/config/liveVideoLayout').default.grid
    }

    resolveUnitName(data) {
        return data.data.description ? data.data.description : data.data.data.description
    }
}

export default VideoViewService
